// TODO use the API to get the list of markets

const ALL_CANADIAN_MARKETS = [
  'toronto',
  'ottawa',
  'kwc',
  'hamilton',
  'calgary',
  'vancouver',
] as const;

const CALIFORNIA_MARKETS = [
  'bay area',
  'san diego',
  'los angeles',
  'sacramento',
] as const;

const ALL_US_MARKETS = [
  ...CALIFORNIA_MARKETS,
  'chicago',
  'denver',
  'austin',
  'dallas',
  'houston',
  'miami',
  'phoenix',
  'new york city',
  'las vegas',
  'seattle',
  'detroit',
] as const;

// Experiment Documentation: https://www.notion.so/opencare/Creating-an-Experiment-188133bf427f418c9de367ef3586db88?pvs=4

export const VARIANTS = Object.freeze({
  CONTROL: 'CONTROL',
  VARIANT: 'VARIANT',
});

export type Market = typeof ALL_CANADIAN_MARKETS[number] | typeof ALL_US_MARKETS[number];

export interface Experiment {
  name: string;
  markets?: readonly Market[];
  excludeMarkets?: readonly Market[];
}

export enum ExperimentName {
  CHECKOUT_REDESIGN_FULLTIME = 'CHECKOUT_REDESIGN_FULLTIME',
  CHECKOUT_REDESIGN_AUTH_FLOW = 'CHECKOUT_REDESIGN_AUTH_FLOW',
  OFFER_MODAL_REDESIGN = 'OFFER_MODAL_REDESIGN',
}

export enum ExperimentVariantType {
  CONTROL = 'CONTROL',
  VARIANT = 'VARIANT',
}

export interface AssignedExperiment {
  name: ExperimentName;
  variant: {
    type: ExperimentVariantType;
    variantNumber: `${number}`; // Stringified number
  };
}

const AUTH_FLOW_MARKETS: Market[] = ['seattle', 'houston', 'phoenix', 'los angeles', 'vancouver', 'chicago'] as const;

/**
 * name: Short name of the experiment. Must match the name in ExperimentConfigs in the API
 * markets: List of markets where the experiment should be run
 */
export const EXPERIMENTS: Record<ExperimentName, Experiment> = {
  // Variants: 1 - new checkout, 2 - new checkout without offer banner
  [ExperimentName.CHECKOUT_REDESIGN_FULLTIME]: {
    name: 'checkout-redesign-fulltime',
    excludeMarkets: AUTH_FLOW_MARKETS,
  },
  // Variants: 0 - new checkout without banner, 1 - new checkout with auth flow
  [ExperimentName.CHECKOUT_REDESIGN_AUTH_FLOW]: {
    name: 'checkout-redesign-auth-flow',
    markets: AUTH_FLOW_MARKETS,
  },
  [ExperimentName.OFFER_MODAL_REDESIGN]: {
    name: 'offer-modal-redesign',
  },
};
